import { render, staticRenderFns } from "./BestSellerPopupModal.vue?vue&type=template&id=72bb225d&scoped=true&"
import script from "./BestSellerPopupModal.vue?vue&type=script&lang=js&"
export * from "./BestSellerPopupModal.vue?vue&type=script&lang=js&"
import style0 from "./BestSellerPopupModal.vue?vue&type=style&index=0&id=72bb225d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bb225d",
  null
  
)

export default component.exports